import { render, staticRenderFns } from "./CompanyMenu.vue?vue&type=template&id=78a7b1f8&scoped=true"
import script from "./CompanyMenu.vue?vue&type=script&lang=js"
export * from "./CompanyMenu.vue?vue&type=script&lang=js"
import style0 from "./CompanyMenu.vue?vue&type=style&index=0&id=78a7b1f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a7b1f8",
  null
  
)

export default component.exports